import React, { useState } from "react";
import TaxRateList from "./index";
import API from "../Services/TaxRate";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const TaxRate = () => {
  const [type, setType] = useState("");
  const [rate, setRate] = useState("");
  const [cess, setCess] = useState("");
  const [entertainment, setEntertainment] = useState("")
  const [otherTax, setOtherTax] = useState("")
  const [errors, setErrors] = useState({});

  const validateFields = () => {
    const errors = {};
  
    if (!type.trim()) {
      errors.type = "Display name is required";
    } else if (!/^[a-zA-Z]/.test(type)) {
      errors.type = "Display name must start with a letter";
    } else if (!/^[a-zA-Z0-9 _-]+$/.test(type)) {
      errors.type = "Enter a Valid Value";
    }
    if (!rate.trim()) {
      errors.rate = "Rate is required";
    } else if (isNaN(parseFloat(rate))) {
      errors.rate = "Rate must be a valid number";
    }
    if (!cess.trim()) {
      errors.cess = "Cess is required";
    } else if (isNaN(parseFloat(cess))) {
      errors.cess = "Cess must be a valid number";
    }
    if (parseFloat(rate) === 0 && parseFloat(cess) !== 0) {
      errors.cess = "Cess must be 0 when Rate is 0";
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFieldChange = (e, fieldName) => {
    const value = e.target.value;
    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[fieldName];
        return updatedErrors;
      });
    }
    switch (fieldName) {
      case "type":
        setType(value);
        break;
      case "rate":
        setRate(value);
        if (parseFloat(value) === 0) {
          setCess("0");
          setErrors((prevErrors) => ({ ...prevErrors, cess: "" }));
        }
        break;
      case "cess":
        setCess(value);
        break;
      case "entertainment":
        setEntertainment(value);
        break;
      case "other":
        setOtherTax(value);
        break;
      default:
        break;
    }
  };

  const handleSubmit = async () => {
    if (!validateFields()) return;
    const payload = {
      type: type.trim(),
      rate: parseFloat(rate) || 0,
      cess: parseFloat(cess) || 0,
      entertainment_tax: entertainment || 0,
      other_tax: otherTax || 0
    };
    try {
      const response = await API.createTaxRate(payload);
      if (response.status === 200) {
        toast.success(response.data.message);
        setTimeout(() => window.location.reload(), 2000);
      } else {
        //setTimeout(() => window.location.reload(), 10000);
      }
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400) {
          toast.error(data.message || "Bad request. Please check your input.");
        }
        else if (status === 403) {
          window.location.replace("/Login");
        }
        else {
          toast.error(`Error: ${status}. ${data.message || "Something went wrong."}`);
        }
      } else if (error.request) {
        console.error("No response received:", error.request);
        toast.error("No response from the server. Please try again later.");
      } else {
        console.error("Error adding tax rate:", error.message);
        toast.error("Failed to add tax rate. Please try again.");
      }
    }
  };

  return (
    <div>
      <div className="col-12 grid-margin stretch-card">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title">Add New</h4>
            <div className="forms-sample">
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="type">Display name <span style={{ color: "red" }}>*</span></label>
                    <input
                      type="text"
                      className={`form-control ${errors.type ? "is-invalid" : ""}`}
                      id="displayname"
                      placeholder="Display name"
                      value={type}
                      onChange={(e) => handleFieldChange(e, "type")}
                    />
                    {errors.type && <div className="invalid-feedback">{errors.type}</div>}
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <label htmlFor="rate">Rate <span style={{ color: "red" }}>*</span></label>
                    <input
                      type="text"
                      className={`form-control ${errors.rate ? "is-invalid" : ""}`}
                      id="rate"
                      placeholder="Rate"
                      value={rate}
                      onChange={(e) => handleFieldChange(e, "rate")}
                    />
                    {errors.rate && <div className="invalid-feedback">{errors.rate}</div>}
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <label htmlFor="cess">Cess <span style={{ color: "red" }}>*</span></label>
                    <input
                      type="text"
                      className={`form-control ${errors.cess ? "is-invalid" : ""}`}
                      id="cess"
                      placeholder="Cess"
                      value={cess}
                      onChange={(e) => handleFieldChange(e, "cess")}
                    />
                    {errors.cess && <div className="invalid-feedback">{errors.cess}</div>}
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="cess">Entertainment Tax</label>
                    <input
                      type="text"
                      className="form-control"
                      id="entertainment"
                      placeholder="Entertainment"
                      value={entertainment}
                      onChange={(e) => handleFieldChange(e, "entertainment")}
                    />

                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <label htmlFor="other">Other Tax</label>
                    <input
                      type="text"
                      className="form-control"
                      id="other"
                      placeholder="Other Tax"
                      value={otherTax}
                      onChange={(e) => handleFieldChange(e, "other")}
                    />

                  </div>
                </div>
              </div>

              <div className="mt-3">
                <button type="button" className="btn btn-primary me-2" onClick={handleSubmit}>
                  Submit
                </button>
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => {
                    setType("");
                    setRate("");
                    setCess("");
                    setEntertainment("")
                    setOtherTax("")
                    setErrors({});
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <TaxRateList />
      <ToastContainer />
    </div>
  );
};

export default TaxRate;


